import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { isCurrentMemberOrgAdmin, isCurrentUserStaffOrSuperAdmin } from 'common/selectors/auth';
import useFeatures from 'common/hooks/useFeatures';
import CopilotFloatingChat from './CopilotFloatingChat';

interface CopilotSlidePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

const CopilotSlidePanel: React.FC<CopilotSlidePanelProps> = ({ isOpen, onClose }) => {
  const { isFeatureEnabled, initialized } = useFeatures();
  const isOrgAdmin = useSelector(isCurrentMemberOrgAdmin);
  const isStaffOrSuperAdmin = useSelector(isCurrentUserStaffOrSuperAdmin);

  const isCopilotEnabled = initialized && isFeatureEnabled('Copilot Enhancements');
  const isAuthorized = isOrgAdmin || isStaffOrSuperAdmin;

  if (!isCopilotEnabled || !isAuthorized) {
    return null;
  }

  return (
    <PanelContainer $isOpen={isOpen}>
      <CopilotFloatingChat isOpen={isOpen} onNewMessage={() => {}} onClose={onClose} />
    </PanelContainer>
  );
};

export default CopilotSlidePanel;

const PanelContainer = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 50px;
  right: 0;
  bottom: 0;
  width: 420px;
  max-width: 100%;
  background: white;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  transform: translateX(${props => (props.$isOpen ? '0' : '100%')});
  transition: transform 0.3s ease-in-out;
  z-index: 950;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: min(100vw, 420px);
  }
`;
